// extracted by mini-css-extract-plugin
module.exports = {"btnEdit":"BtnPermitActions_btnEdit__vptNQ","disabledBtn":"BtnPermitActions_disabledBtn__1gPIK"};